import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const depositOpportunitiesAnalysisSlice = createApi({
  reducerPath: "analysis_secondary_consumer",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["deposit_opportunities"],
  endpoints: (build) => ({
    getDepositOpportunitiesSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=deposit_opportunities&view=summary&page=0&size=10`,
        url: `/bank/${orgId}/dashboard/${payload.requid}/deposit_opportunities/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      transformResponse: (response) => {
        if (response.status === "SUCCESS") {
          let res = response?.data;

          return { ...response, data: res };
        } else {
          return { ...response, data: null };
        }
      },
    }),

    getDepositOpportunitiesExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        // url: `bank/${orgId}/dashboard?card=deposit_opportunities&view=expand&page=0&size=10`,
        url: `/bank/${orgId}/dashboard/${payload.requid}/deposit_opportunities/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      transformResponse: (response) => {
        if (response.status === "SUCCESS") {
          let res = response?.data;

          return { ...response, data: res };
        } else {
          return { ...response, data: null };
        }
      },
    }),
  }),
});

export const {
  useGetDepositOpportunitiesSummaryQuery,
  useGetDepositOpportunitiesExpandedQuery,
} = depositOpportunitiesAnalysisSlice;
